/* eslint-disable no-unused-vars */
export default {
  setEnabled({ commit }, enabled) {
    commit("SET_ENABLED", enabled);
  },
  setShortcuts({ commit }, payload) {
    commit("SET_SHORTCUTS", payload);
  },
};
